import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints } from 'src/api/APIEndpoints';
import { ITreeItemParentBinderView } from '../modelviewer/types';
import { baseQuery } from './baseQuery';

export const binderViewerApi = createApi({
  baseQuery: baseQuery,
  reducerPath: 'binderViewerApi',
  endpoints: builder => ({
    getAllBinderViewer: builder.query<ITreeItemParentBinderView[], void>({
      query: () => ({
        url: endPoints.tmfLevel.getAll.url
      }),
      keepUnusedDataFor : endPoints.tmfLevel.getAll.keepUnusedDataFor
    }),

  })
});

export const { useGetAllBinderViewerQuery } = binderViewerApi;
